export default "__VITE_ASSET__zWowgLnE__"